import React from 'react'
import PropTypes from 'prop-types'

class CertificationRangeSelect extends React.Component {
  state = {
    selectedRangeId: ''
  }

  onChange = (e) => {
    this.setState({ selectedRangeId: e.target.value })
    setTimeout(function() { this.props.newCertificationRangeCallback(this.state.selectedRangeId); }.bind(this), 300)
  }

  render() {
    return(
      <div className='col-md-3 col-xs-12'>
        <select className='form-control'
                title='select date range'
                value={this.state.selectedRangeId}
                onChange={(e) => this.onChange(e)}>
          <option value=''>
            All Date Ranges
          </option>
          <option value='1'>
            Expired
          </option>
          <option value='2'>
            Expiring in 0-90 days
          </option>
          <option value='3'>
            Expiring in 90+ days
          </option>
        </select>
      </div>
    )
  }
}

export default CertificationRangeSelect
